import React from 'react';

const ErrorFallback = ({error}) => {
    return (
        <div>
            <h1>Application Error</h1>
            <pre style={{whiteSpace: 'pre-wrap'}}>{error.toString()}</pre>
            {error?.stack ? (
                <>
                    <h2>Stack trace</h2>
                    <pre style={{whiteSpace: 'pre-wrap', fontSize: '12px'}}>{error.stack}</pre>
                </>
            ) : null}
        </div>
    );
};

export default React.memo(ErrorFallback);
